import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { LayoutDashboard, Package, Receipt, ThumbsUp, Candy, Menu, Bell, LogOut } from "lucide-react";
import { AppSettingsSheet } from "@/components/AppSettings";

const PRIMARY = [
  ["overview", "Oversigt", LayoutDashboard],
  ["products", "Produkter", Package],
  ["bills", "Regninger", Receipt],
  ["jatak", "Ja tak", ThumbsUp],
  ["slik", "Slik", Candy],
];

export function MobileBottomNav({ tab, setTab, groups, labels, onLogout }) {
  const [moreOpen, setMoreOpen] = useState(false);
  const [appOpen, setAppOpen] = useState(false);
  const primaryIds = PRIMARY.map((p) => p[0]);
  const inMore = !primaryIds.includes(tab);

  const go = (id) => { setTab(id); setMoreOpen(false); window.scrollTo({ top: 0 }); };

  return (
    <>
      <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-[#e9edf1] pb-[env(safe-area-inset-bottom)]" data-testid="bottom-nav">
        <div className="grid grid-cols-6">
          {PRIMARY.map(([id, label, Icon]) => (
            <button key={id} onClick={() => go(id)} data-testid={`bnav-${id}`}
              className={`flex flex-col items-center justify-center gap-0.5 py-2 text-[10.5px] font-medium transition-colors ${tab === id ? "text-[#C8102E]" : "text-slate-500"}`}>
              <Icon className="w-5 h-5" strokeWidth={tab === id ? 2.4 : 1.8} />
              {label}
            </button>
          ))}
          <button onClick={() => setMoreOpen(true)} data-testid="bnav-more"
            className={`flex flex-col items-center justify-center gap-0.5 py-2 text-[10.5px] font-medium ${inMore ? "text-[#C8102E]" : "text-slate-500"}`}>
            <Menu className="w-5 h-5" strokeWidth={inMore ? 2.4 : 1.8} />
            Mere
          </button>
        </div>
      </nav>

      <Sheet open={moreOpen} onOpenChange={setMoreOpen}>
        <SheetContent side="bottom" className="rounded-t-2xl bg-[#F6F7F9] max-h-[85vh] overflow-y-auto pb-[calc(env(safe-area-inset-bottom)+1.5rem)]" data-testid="more-sheet">
          <SheetHeader className="text-left mb-3">
            <SheetTitle>Alle faner</SheetTitle>
            <SheetDescription className="sr-only">Vælg en fane</SheetDescription>
          </SheetHeader>
          <div className="space-y-4">
            {groups.map((g) => (
              <div key={g.label}>
                <div className="flex items-center gap-1.5 mb-1.5">
                  <g.icon className="w-3.5 h-3.5 text-slate-400" />
                  <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-400">{g.label}</span>
                </div>
                <div className="grid grid-cols-2 gap-1.5">
                  {g.ids.map((id) => (
                    <button key={id} onClick={() => go(id)} data-testid={`more-tab-${id}`}
                      className={`text-left px-3 py-2.5 rounded-xl text-sm font-medium border transition-colors ${tab === id ? "bg-[#C8102E] border-[#C8102E] text-white" : "bg-white border-[#e9edf1] text-slate-700"}`}>
                      {labels[id]}
                    </button>
                  ))}
                </div>
              </div>
            ))}
            <div className="grid grid-cols-2 gap-1.5 pt-1">
              <button onClick={() => { setMoreOpen(false); setAppOpen(true); }} data-testid="more-app-settings"
                className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm font-medium bg-white border border-[#e9edf1] text-slate-700">
                <Bell className="w-4 h-4 text-[#C8102E]" /> App & notifikationer
              </button>
              <button onClick={onLogout} data-testid="more-logout"
                className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm font-medium bg-white border border-[#e9edf1] text-slate-500">
                <LogOut className="w-4 h-4" /> Log ud
              </button>
            </div>
          </div>
        </SheetContent>
      </Sheet>

      <AppSettingsSheet open={appOpen} onOpenChange={setAppOpen} />
    </>
  );
}
